<template>
  <dialog ref="main" class="gp_dialog">
    <!-- <div class="gp_dialog-backdrop" @mousedown.prevent="overlayClick" v-if="!noBackdrop"></div> -->
    <div class="gp_dialog-backdrop" @mousedown.prevent="overlayClick"></div>
    <div class="gp_dialog-container" :class="containerClass">
      <section class="d-flex flex-column align-items-center justify-content-center">
        <div v-if="item?.type.endsWith(':success')" class="img-holder">
          <svg xmlns="http://www.w3.org/2000/svg" width="57" height="57" viewBox="0 0 57 57">
            <g transform="translate(-732 -89)">
              <circle cx="28.5" cy="28.5" r="28.5" transform="translate(732 89)" fill="#d0fccf" />
              <g transform="translate(750 42.003)">
                <g transform="translate(0 67.997)">
                  <path
                    d="M21.1,68.311a1.071,1.071,0,0,0-1.515,0L6.76,81.142,1.828,76.21A1.071,1.071,0,0,0,.313,77.725L6,83.414a1.071,1.071,0,0,0,1.515,0L21.1,69.826A1.071,1.071,0,0,0,21.1,68.311Z"
                    transform="translate(0 -67.997)"
                    fill="#148300" />
                </g>
              </g>
            </g>
          </svg>
        </div>
        <div v-if="item?.type.endsWith(':error')" class="img-holder">
          <svg xmlns="http://www.w3.org/2000/svg" width="57" height="57" viewBox="0 0 57 57">
            <g transform="translate(-732 -89)">
              <circle cx="28.5" cy="28.5" r="28.5" transform="translate(732 89)" fill="#ffecb9" />
              <g id="warning-sign" transform="translate(573.773 107)">
                <path
                  d="M186.727,16.1a1.49,1.49,0,0,0,1.484-1.365l1.007-12.026a2.5,2.5,0,1,0-4.983,0l1.007,12.026A1.49,1.49,0,0,0,186.727,16.1Z"
                  transform="translate(0)"
                  fill="#ffba00" />
                <path
                  d="M207.076,410.908a1.623,1.623,0,1,0,1.623,1.623A1.622,1.622,0,0,0,207.076,410.908Z"
                  transform="translate(-20.348 -393.923)"
                  fill="#ffba00" />
              </g>
            </g>
          </svg>
        </div>
        <div class="dialog-message d-flex flex-column align-items-center justify-content-center">
          <component
            :is="item.title.tag || 'div'"
            v-if="item && item.title"
            :class="item.title.class || 'typo-h20 typo-semibold text-light-high text-center'"
            v-html="item.title.text"></component>
          <component
            :is="item.content.tag || 'div'"
            v-if="item && item.content"
            :class="item.content.class || 'typo-p16 typo-semibold text-light-high text-center'"
            v-html="item.content.text"></component>
          <button class="btn btn-primary btn-default mt-2 px-4" @click.prevent="closeDialog">OK</button>
        </div>
      </section>
    </div>
  </dialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'GDialog',
  props: {
    item: Object,
  },
  computed: {
    containerClass() {
      if ((this.item as any)?.containerClass) {
        return (this.item as any).containerClass;
      }
      return 'p-4';
    },
  },
  methods: {
    overlayClick() {},
    closeDialog() {
      this.$emit('close', this.item?.id);
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/color';
$baseIndex: $modalIndex;
.gp_dialog {
  position: fixed;
  z-index: $baseIndex;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  @include flex-center;

  &-backdrop {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 5;
    background: rgba(#000, 0.5);
  }

  &-container {
    position: relative;
    background: $bg;
    width: 100%;
    max-width: 560px;
    max-height: 100%;
    display: flex;
    z-index: 10;
    flex-direction: column;
    border-radius: $radius;
  }
}
</style>
